import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import Drawer from 'react-modern-drawer';
import TransactionServices from "../TransactionServices";

export default function MatchingForm(param: any) {

    const [showtab, setShowTab] = useState(1);
    const [loop, setloop] = useState(1);
    let [activeMenu, setActiveMenu] = useState("MatchingForm");
    const [searchFor, setSearchFor] = useState("");
    var dataLink = "pageSize=10&pageNumber=1";
    const [currentList, initCurrentList] = useState<any[]>([]);
    const [totalRows, setTotalRows] = useState(1);


    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }

    let [territoryCode, setTerritoryCode] = useState<any[]>([]);
    const matchingTerritoriesAliases = () => {
        TransactionServices.territoryCode({}).then((res: any) => {
            console.log(res)
            territoryCode = res
            setTerritoryCode(res)
        })
    }

    let [matchingFormat, setMatchingFormat] = useState<any[]>([]);
    const CodingStr = () => {
        TransactionServices.getCodingStr({}).then((res: any) => {
            console.log(res)
            matchingFormat = res
            setMatchingFormat(res)
        })
    }


    let [territoryAlias, setTerritoryAlias] = useState<any[]>([]);
    const territoryAliases = () => {
        TransactionServices.getTerritoryCode({}).then((res: any) => {
            console.log(res)
            territoryAlias = res
            setTerritoryAlias(res)
            console.log("test for load all aliases button")
        })
    }

    let [formatAlias, setFormatAlias] = useState<any[]>([]);
    const formatalias = () => {
        TransactionServices.getFormatAlias({}).then((res: any) => {
            console.log(res)
            formatAlias = res
            setFormatAlias(res)
            console.log("test button for load all aliases formatalias")
        })
    }



    let [matchingSongs, setMatchingSongs] = useState<any[]>([]);

    let [matchingCatalogViewAll, setMatchingCatalogViewAll] = useState<any[]>([]);
    const matchingCalatog = () => {
        var payload = { accountCode: '', ourCode: '', pageNumber: 1, pageSize: 10, search: '' }
        TransactionServices.getRelAliases(payload).then((res: any) => {
            console.log(res)
            matchingCatalogViewAll = res
            setMatchingCatalogViewAll(res)
            console.log("matching catalogs form view all button test")
        })
    }

    useEffect(() => {
        matchingTerritoriesAliases()
    }, [param.param, showtab])

    let [postFactSalesCommitTrue, setPostFactSalesCommitTrue] = useState(false);
    let [postFactSalesCommitFalse, setPostFactSalesCommitFalse] = useState(false);
    let [updateSystemAliasTrue, setUpdateSystemAliasTrue] = useState(false);
    let [updateSystemAliasFalse, setUpdateSystemAliasFalse] = useState(false);
    let [aliasError, setAliasError] = useState(false);
    let [saveTAlias, setSaveTAlias] = useState(false);
    let [deleteTerritoryAliase, setDeleteTerritoryAliase] = useState(false);

    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }

    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        totalRows: 0
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        dataLink = 'pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        currentPage(showtab)
    }

    const currentPage = (e: number) => {
        setShowTab(e);

        if (searchFor.length > 0) {
            dataLink = dataLink + "&searchFor=" + searchFor
        }
        if (e === 1) {
            TransactionServices.territoryCode({}).then((res: any) => {
                console.log(res)
                territoryCode = res
                setTerritoryCode(res)
            })
        }
        if (e === 2) {
            TransactionServices.getCodingStr({}).then((res: any) => {
                console.log(res)
                matchingFormat = res
                setMatchingFormat(res)

            })
        }
        if (e === 3) {
            //let [matchingCalatog, setMatchingCalatog] = useState<any[]>([]);
            TransactionServices.matchingCalatog({}).then((res: any) => {
                console.log(res)
                territoryCode = res
                setTerritoryCode(res)
            })
        }
        if (e === 4) {
            TransactionServices.matchingSongs({}).then((res: any) => {
                console.log(res)
                territoryCode = res
                setTerritoryCode(res)
            })
        }
    }
    let [allFterritoriesAlias, setAllFterritoriesAlias] = useState(false);
    let [territoriesAlias, setTerritoriesAlias] = useState(false);
    let [updateMatchingFormatResultsTrue, setUpdateMatchingFormatResultsTrue] = useState(false);
    let [updateMatchingFormatResultsFalse, setUpdateMatchingFormatResultsFalse] = useState(false);
    let [saveErrorFormats, setSaveErrorFormats] = useState(false);
    let [saveAlertFormats, setAaveAlertFormats] = useState(false);
    let [deleteSuccess, setDeleteSuccess] = useState(false);
    let [updateMatchingResultsTrue, setUpdateMatchingResultsTrue] = useState(false);
    let [updateMatchingResultsFalse, setUpdateMatchingResultsFalse] = useState(false);
    let [saveDuplicateError, setSaveDuplicateError] = useState(false);
    let [codeError, setCodeError] = useState(false);
    let [searchError, setSearchError] = useState(false);
    let [noExistingAliases, setNoExistingAliases] = useState(false);
    let [unMatchedFormats, setUnMatchedFormats] = useState(false);
    let [searchVisible, setSearchVisible] = useState(false);
    let [noExistingFormats, setNoExistingFormats] = useState(false);
    let [catalogsUnMatched, setCatalogsUnMatched] = useState(false);
    let [allFilteredCompilations, setAllFilteredCompilations] = useState(false);
    let [allFilteredTracks, setAllFilteredTracks] = useState(false);
    let [allExistingAliases, setAllExistingAliases] = useState(false);
    let [allFilteredContracts, setAllFilteredContracts] = useState(false);
    let [allFilteredClassList, setAllFilteredClassList] = useState(false);
    let [selectAccountCode, setSelectAccountCode] = useState(false);
    let [catalogsUnMatchedAccountCode, setCatalogsUnMatchedAccountCode] = useState(false);
    let [repItemCodeSoldEmpty, setRepItemCodeSoldEmpty] = useState(false);
    let [catalogSaveError, setCatalogSaveError] = useState(false);
    let [catalogSaveSuccess, setCatalogSaveSuccess] = useState(false);
    let [catalogDeleteSuccess, setCatalogDeleteSuccess] = useState(false);




    return (
        <Drawer open={param.param} onClose={() => returnValue(2)} direction='right' className='react-drawer allowHscroll' size={1200}>

            <div className="ws-8 box pull-right">
                <div className="box-content">
                    <ul className="nav nav-tabs nav-justified">
                        <a id="1" className={showtab === 1 ? "btn-success active" : "btn-success"} onClick={() => currentPage(1)}>Matching Territories</a>
                        <a id="2" className={showtab === 2 ? "btn-success active" : "btn-success"} onClick={() => currentPage(2)}>Matching Formats/Source Codes</a>
                        <a id="3" className={showtab === 3 ? "btn-success active" : "btn-success"} onClick={() => currentPage(3)}>Matching Catalogs</a>
                        <a id="4" className={showtab === 4 ? "btn-success active" : "btn-success"} onClick={() => currentPage(4)}>Matching Songs</a>
                    </ul>

                    {
                        postFactSalesCommitTrue && <div className="alert alert-info">Operation successfully queued for processing</div>
                    }
                    {
                        postFactSalesCommitFalse && <div className="alert alert-info">Re-run this operation after a few mins as same operation already in progress</div>
                    }

                    {showtab === 1 && <div className="slide" data-ng-show="isActiveTab(0)">

                        <div className="box">

                            <div className="box-header well">
                                <h2 ><i className="icon-clone"></i> Matching Territories</h2>
                            </div>

                            <div className="box-content form-box">
                                {
                                    updateSystemAliasTrue && <div className="alert alert-info">Operation queued for processing</div>
                                }

                                {
                                    updateSystemAliasFalse && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>
                                }

                                {
                                    aliasError && <div className="alert alert-info">Please select an unmatched territory followed by the system territory</div>
                                }

                                <div className="row-fluid">

                                    <div className="ws-4">

                                        <div className="label-entries">
                                            <input type="text" className="form-control ng-pristine ng-valid ng-touched ng-untouched" placeholder="Filter Unmatched entries" data-ng-model="territoryCodeUnmatchFilter" id="unmatchedEntries" />
                                            <select className="ws-12 height194  " id="regions" ng-model="alias.terrAlias" ng-options="territory.repTerritoryCode as territory.repTerritoryCode for territory in unmatchedTerritories | filter:{ repTerritoryCode : territoryCodeUnmatchFilter }">
                                                <option value="" >Choose unmatched territory</option>
                                            </select>
                                        </div>

                                    </div>
                                    <div className="ws-4">
                                        <div className="label-entries">
                                            <input type="text" className="form-control " placeholder="Filter System territories" data-ng-model="territoryCodeFilter" id="search" />
                                            <select className="ws-12 height194 " id="regions" ng-model="alias.terrOurs" ng-options="territory.territoryCode as territory.territoryCode group by territory.territoryName for territory in availableTerritories | filter: territoryCodeFilter">
                                                <option value="" >Choose system territory</option><optgroup label="Afghanistan">
                                                    <option value="0" label="AF">AF</option></optgroup><optgroup label="Åland Islands">
                                                    <option value="1" label="AX">AX</option></optgroup><optgroup label="Albania">
                                                    <option value="2" label="AL">AL</option></optgroup><optgroup label="Algeria">
                                                    <option value="3" label="DZ">DZ</option></optgroup><optgroup label="All Undefined">
                                                    <option value="4" label="ZZ">ZZ</option></optgroup><optgroup label="American Samoa">
                                                    <option value="5" label="AS">AS</option></optgroup><optgroup label="Andorra">
                                                    <option value="6" label="AD">AD</option></optgroup><optgroup label="Angola">
                                                    <option value="7" label="AO">AO</option></optgroup><optgroup label="Anguilla">
                                                    <option value="8" label="AI">AI</option></optgroup><optgroup label="Antarctica">
                                                    <option value="9" label="AQ">AQ</option></optgroup><optgroup label="Antigua and Barbuda">
                                                    <option value="10" label="AG">AG</option></optgroup><optgroup label="Argentina">
                                                    <option value="11" label="AR">AR</option></optgroup><optgroup label="Armenia">
                                                    <option value="12" label="AM">AM</option></optgroup><optgroup label="Aruba">
                                                    <option value="13" label="AW">AW</option></optgroup><optgroup label="Australia">
                                                    <option value="14" label="AU">AU</option></optgroup><optgroup label="Austria">
                                                    <option value="15" label="AT">AT</option></optgroup><optgroup label="Azerbaijan">
                                                    <option value="16" label="AZ">AZ</option></optgroup><optgroup label="Bahamas">
                                                    <option value="17" label="BS">BS</option></optgroup><optgroup label="Bahrain, Kingdom of">
                                                    <option value="18" label="BH">BH</option></optgroup>
                                            </select>
                                        </div>

                                    </div>

                                    <div className="ws-4">
                                        <label className="control-label " >Unmatched entries</label>

                                        <div className="label-entries">
                                            <input type="text" className="form-control " placeholder="Unmatched entries" data-ng-model="alias.terrAlias" id="unmatchedentries" readOnly />
                                        </div>

                                    </div><div className="ws-4">

                                        <label className="control-label " >Match to</label>
                                        <div className="label-entries">
                                            <input type="text" className="form-control " placeholder="Matched entries" data-ng-model="alias.terrOurs" id="matchTo" readOnly />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="box-footer">
                                <a href="javascript:void(0)" className="icon-btn edit pull-right " data-ng-click="createAlias()"><i className="icon-list icon-white"></i> Create Alias</a>

                                <button className="icon-btn primary pull-right" ng-click="unmatchedEntriesExport()" title="Unmatched territories">
                                    <i className="icon-download1"></i>
                                </button>
                            </div>
                        </div>

                        <div className="box clearfix">
                            <div className="box-header well">
                                <h2 ><i className="icon-info"></i> Existing Territories Alias
                                    <span data-ng-show="territoriesAlias.length &gt; 0" className="">-  record(s) found</span>
                                </h2>
                            </div>

                            {
                                aliasError && <div className="alert alert-info">has been matched successfully with System territories</div>
                            }
                            {
                                deleteTerritoryAliase && <div className="alert alert-info">Matched Territory  has been deleted successfully</div>
                            }

                            <div className="box-content">

                                <div data-ng-hide="territoriesAlias != null &amp;&amp; territoriesAlias.length == 0">

                                    <button className="icon-btn primary btn-sm mb w-12" onClick={territoryAliases} data-ng-hide="territoriesAlias.length &gt; 0">
                                        <i className="icon-arrow-down ws-1 m0 p0"></i>
                                        <span className="ws-11 ">
                                            Load all aliases
                                        </span>
                                    </button>

                                    <div className="form-horizontal row-fluid" data-ng-show="territoriesAlias.length &gt; 0">
                                        <div className="form-format ws-6">
                                            <label className="control-label ">Filter</label>

                                            <div className="label-entries">
                                                <input type="text" className="form-control input-sm " placeholder="Search" data-ng-model="filter.territory" id="territory" />
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        allFterritoriesAlias && <div className="alert alert-int">No record matches your search criteria</div>
                                    }
                                    {
                                        territoriesAlias && <div className="alert alert-int">No Territories Alias added yet</div>
                                    }

                                </div>
                                <div className="table-responsive_big" data-ng-show="territoriesAlias.length &gt; 0">

                                    <table className="table" data-ng-show="allFterritoriesAlias != null &amp;&amp; allFterritoriesAlias.length &gt; 0">
                                        <thead>
                                            <tr>
                                                <th >Unmatched Territory</th>
                                                <th >System Territory</th>
                                                <th >Operation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {territoryAlias?.map(values => {
                                                return (
                                                    <tr>
                                                        <td>{values.terrAlias}</td>
                                                        <td>{values.terrOurs}</td>
                                                        <td>{ }</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="clearfix mt" data-ng-show="territoriesAlias.length &gt; 0">

                                </div>

                            </div>
                        </div>

                    </div>}

                    {showtab === 2 && <div className="slide" data-ng-show="isActiveTab(1)">

                        <div className="row-fluid sortable box">

                            <div className="box-header well">
                                <h2 ><i className="icon-file-archive-o"></i> Matching Formats/Source Codes</h2>
                            </div>



                            <div className="box-content">

                                {
                                    updateMatchingFormatResultsTrue && <div className="alert alert-info">Operation queued for processing</div>
                                }
                                {
                                    updateMatchingFormatResultsFalse && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>
                                }

                                <form className="form-horizontal form-condensed ng-pristine ng-invalid ng-invalid-required" name="frmformats">

                                    {
                                        saveErrorFormats && <div className="alert alert-info">Check at least one unmatched format to associate and fill in the required fields</div>
                                    }




                                    <div className="form-format ws-6">
                                        <label >Account Code*</label>

                                        <div className="label-entries">
                                            <select  /* placeholder="Choose Account Code" */ ng-model="formatAlias.accountCode" ng-className="{requiredFocus:frmformats.$submitted &amp;&amp; frmformats.accountCode.$invalid}" id="accountCode" name="accountCode" ng-required="true" ng-change="onChangeAccountCode();clearFilterFormatsTable();" required><option value="" >Choose Account Code</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-format ws-6">
                                        <label >Formats/Source Codes*</label>

                                        <div className="label-entries">
                                            <select  /* placeholder="Choose Formats/Source Codes Report" */ ng-model="formatAlias.ourCode"  ng-className="{requiredFocus:frmformats.$submitted &amp;&amp; frmformats.formatreport.$invalid}" data-ng-change="filterFormatsTable()" id="formatreport" name="formatreport" ng-required="true" required><option value="" >Choose Formats/Source Codes Report</option></select>
                                        </div>
                                    </div>
                                    {selectAccountCode &&
                                        <div className="alert alert-info m0 " data-ng-show="formatAlias.accountCode.code == null"> Select an account code
                                        </div>}

                                    {unMatchedFormats &&
                                        <div className="alert alert-info m0" data-ng-show="unmatchedData.length == 0 &amp;&amp; formatAlias.accountCode.code != null">No unmatched formats for the selected account code
                                        </div>
                                    }

                                    <div className="box-header well" data-ng-show="unmatchedTotalItems &gt; 0">
                                        <h4 > <i className="icon-info"></i>
                                            record(s) found</h4>
                                    </div>

                                    <table className="table" data-ng-show="unmatchedData.length &gt; 0">
                                        <tbody><tr>
                                            <th><input type="checkbox" data-ng-model="selectAllFormatsFlag[unmatchedCurrentPage]" data-ng-change="selectAllFormats(itemsPerPage)" title="Select All Formats" className="" /></th>
                                            <th >Sub content</th>
                                            <th >Sub Formats/Source Codes</th>
                                            <th >Sub provider</th>
                                        </tr>

                                        </tbody></table>
                                    <div className="clearfix">

                                    </div>

                                </form>
                            </div>

                            <div className="box-footer">
                                <button className="icon-btn edit " ng-click="frmformats.$submitted=true; formatSave(frmformats, formats)"><i className="icon-save-disk"></i> Save
                                </button>
                                <button className="btn-pink " ng-click="onMatchFormatsClear(frmformats)">
                                    <i className="icon-refresh"></i>
                                    Reset
                                </button>
                                <button className="btn btn-pink" ng-click="onMatchFormatsRefresh()" data-ng-show="formatAlias.accountCode.code != null">
                                    <i className="icon-reload"></i> Refresh
                                </button>
                                <button className="icon-btn edit" title="Unmatched Formats for all Account Code" ng-click="matchingFormatsExport('All');">
                                    <i className="icon-download1"></i>
                                </button>
                                <button className="icon-btn edit" ng-show="unmatchedTotalItems &gt; 0" title="Unmatched Formats" ng-click="matchingFormatsExport(formatAlias.accountCode.code);">
                                    <i className="icon-download1"></i>
                                </button>
                            </div>

                        </div>

                        <div className="box-header well  t_margin">
                            <h2 ><i className="icon-info"></i> Existing Formats/Source Codes Aliases
                                <span data-ng-show="formatsFilterred.length &gt; 0" className=""> -
                                    record(s) found</span>
                            </h2>
                        </div>

                        <div className="box-content">
                            {
                                saveAlertFormats && <div className="alert alert-info">Format  has been saved successfully</div>
                            }
                            {
                                deleteSuccess && <div className="alert alert-info">Format  has been deleted successfully</div>
                            }
                            <button className="icon-btn primary mb w-12" data-ng-show="loadButtonVisible" onClick={formatalias}>
                                <i className="icon-arrow-down ws-1 m0 p0"></i> <span className="ws-11 ">
                                    Load all aliases
                                </span>
                            </button>
                            <div className="form-horizontal row-fluid" data-ng-show="allFormats.length &gt; 0">
                                <div className="form-format">
                                    <label >Filter</label>
                                    <div className="label-entries">
                                        <input type="text" className="form-control input-sm " placeholder="Search" data-ng-model="filter.formats" id="formats" />
                                    </div>
                                </div>
                            </div>

                            {searchVisible &&
                                <div className="alert alert-info" data-ng-show="c.length == 0 &amp;&amp; searchVisible">
                                    No records found
                                </div>
                            }

                            {noExistingFormats &&
                                <div className="alert alert-info" data-ng-show="formatsFilterred.length == 0  &amp;&amp; !searchVisible &amp;&amp; !loadButtonVisible">
                                    No existing format aliases added yet
                                </div>}

                            <div className="table-responsive_big">

                                <table className="table" data-ng-show="formatsFilterred.length &gt; 0">
                                    <thead>
                                        <tr>
                                            <th >Format to Report</th>
                                            <th >SubContent</th>
                                            <th >SubFormat</th>
                                            <th >SubProvider</th>
                                            <th >Account Code</th>
                                            <th >Operation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formatAlias?.map(values => {
                                            return (
                                                <tr>
                                                    <td>{values.ourCode}</td>
                                                    <td>{values.subContent}</td>
                                                    <td>{values.subFormat}</td>
                                                    <td>{values.subProvider}</td>
                                                    <td>{values.accountCode}</td>
                                                    <td>{ }</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            <div className="clearfix mt">
                                <ul className="pull-left m0 mt pagination ng-isolate-scope ng-valid" total-items="formatsTotalItems" ng-model="formatsCurrentPage" max-size="3" ng-change="formatsPageChanged(formatsCurrentPage, formatsItemsPerPage)" data-ng-show="formatsTotalItems &gt; 10" data-items-per-page="formatsItemsPerPage">

                                    <li ng-if="::directionLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page - 1, $event)" >Previous</a></li>
                                    <li ng-repeat="page in pages track by $index" ng-className="{active: page.active,disabled: ngDisabled&amp;&amp;!page.active}" className=" active"><a href="" ng-click="selectPage(page.number, $event)" >1</a></li>
                                    <li ng-if="::directionLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page + 1, $event)" >Next</a></li>

                                </ul>

                                <div className="page-size-control mt">
                                    <select title="Items per page" data-ng-options="item as item for item in pageSizes" data-ng-change="formatsCurrentPage= 1; formatsPageChanged(formatsCurrentPage, formatsItemsPerPage)" data-ng-model="formatsItemsPerPage" data-ng-show="formatsTotalItems &gt; 10" className=""><option value="?" selected label=""></option><option value="0" label="10">10</option><option value="1" label="20">20</option><option value="2" label="50">50</option><option value="3" label="100">100</option></select>
                                </div>

                                <button className="icon-btn edit mt" ng-click="exportFormats('dl')" data-ng-show="formatsFilterred.length &gt; 0">
                                    <i className="icon-download1"></i>
                                </button>
                                <a id="dl" href="javascript:void(0)"></a>
                            </div>
                        </div>

                    </div>}

                    {showtab === 3 && <div className="slide" data-ng-show="isActiveTab(2)">

                        <div className="box">
                            <div className="box-header well">
                                <h2 ><i className="icon-search1"></i> Matching Catalogs</h2>
                            </div>

                            <div className="box-content">
                                {
                                    updateMatchingResultsTrue && <div className="alert alert-info">Operation queued for processing</div>
                                }

                                {
                                    updateMatchingResultsFalse && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>
                                }

                                <form className="form-horizontal form-condensed ng-pristine ng-valid">
                                    <div className="form-format ">
                                        <div className="form-horizontal">
                                            <div className="ws-6">
                                                <label >Account Code*</label>
                                                <div className="label-entries">
                                                    <select className="form-control "  /* placeholder="Choose Account Code" */ ng-model="catalog.accountCode" id="accountCode" name="accountCode" ng-change="onChangeCatalogueAccountCode(catalog.accountCode)"><option value="" >Choose an Account Code</option></select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-format " data-ng-show="catalog.accountCode">
                                        <div className="form-horizontal">
                                            <div className="ws-6 mb">
                                                <label className="control-label ">Search</label>
                                                <div className="ws-4">
                                                    <input type="text" className="input-sm m0 ws-12 " placeholder="Search unmatched catalogs" data-ng-model="filter.catalog" id="catLog" />
                                                </div>
                                                <div className="ws-4">
                                                    <button className="btn icon-btn edit" data-ng-click="pages.unmatched = 1;loadCatalogByAccountCode()">
                                                        <i className="icon-search"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        catalogsUnMatched &&
                                        <div className="alert alert-info m0 mb" data-ng-show="catalogsUnMatched.length == 0 &amp;&amp; (catalog.accountCode.code != '' &amp;&amp; catalog.accountCode.code != null)">
                                            No catalogue found for the selected account code or matching your search criteria
                                        </div>
                                    }
                                    {catalogsUnMatchedAccountCode && <div className="alert alert-info m0" data-ng-show="catalogsUnMatched.length == 0 &amp;&amp; (catalog.accountCode.code == '' || catalog.accountCode.code == null)">
                                        Select an account code
                                    </div>}

                                    <div className="box-header well" data-ng-show="catalogUnmatchedTotalItems &gt; 0">
                                        <h4 >
                                            <i className="icon-info"></i>
                                            record(s) found
                                        </h4>
                                    </div>
                                    <div className="table-responsive_big">
                                        <table className="table t_margin" data-ng-show="catalogsUnMatched.length &gt; 0">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th >Rep item code sold</th>
                                                    <th >
                                                        Album Title
                                                        <span ng-click="sortByValueOrder = true; sortBy = 'albumTitle'; onMatchCataloguesRefresh();">
                                                            <i className="icon-sort-up pull-right text-xl"></i></span>
                                                        <span ng-click="sortByValueOrder = false; sortBy = 'albumTitle'; onMatchCataloguesRefresh();">
                                                            <i className="icon-sort-down pull-right text-xl"></i></span>
                                                    </th>
                                                    <th >Album Artist</th>
                                                    <th >Track(s)/Song(s) Title
                                                    </th>
                                                    <th >Track(s)/Song(s) Artist</th>
                                                    <th >Album code 1</th>
                                                    <th >Album code 2</th>
                                                    <th >Track(s)/Song(s) code 1</th>
                                                    <th >Track(s)/Song(s) code 2</th>
                                                    <th >Subformat</th>
                                                    <th >Item code sold</th>
                                                    <th >
                                                        Unmatched value

                                                        <span ng-click="sortByValueOrder = true; sortBy = 'unMtchValue'; onMatchCataloguesRefresh();">
                                                            <i className="icon-sort-up text-xl pull-right"></i></span>
                                                        <span ng-click="sortByValueOrder = false; sortBy = 'unMtchValue'; onMatchCataloguesRefresh();">
                                                            <i className="icon-sort-down text-xl pull-right"></i></span>
                                                    </th>
                                                    <th >Operation</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            </tbody>
                                        </table>
                                    </div>
 
                                    <div className="clearfix mb"> 

                                        <button className="pull-right btn icon-btn edit btn-xs" field-separator="," ng-csv="exportCUnmatchedRows()" csv-header="exportCUnmatchedHeaders()" data-ng-show="allcatalogsUnMatched.length &gt; 0">
                                            <i className="icon-download1"></i>
                                        </button>
                                        <button className="btn icon-btn edit btn-sm pull-right mt" ng-show="catalogUnmatchedTotalItems &gt; 0" title="Export Unmatched Catalogs" ng-click="matchingCataloguesExport(catalog.accountCode.code);">
                                            <i className="icon-download1"></i>
                                        </button>
                                        <button className="btn btn-pink btn-sm pull-right mt " ng-click="onMatchCataloguesRefresh()" data-ng-hide="catalogsUnMatched.length == 0 &amp;&amp; (catalog.accountCode.code == '' || catalog.accountCode.code == null)">
                                            <i className="icon-reload"></i> Refresh
                                        </button>
                                    </div>

                                    <div className="form-format mtl">
                                        <div className="ws-12">
                                            <div className="ws-2">
                                                <input type="text" data-ng-model="searchC.trackTitle" className="form-control-single " placeholder="Track(s)/Song(s) title" />
                                            </div>
                                            <div className="ws-2">
                                                <input type="text" data-ng-model="searchC.trackArtist" className="form-control-single " placeholder="Track(s)/Song(s) artist" />
                                            </div>
                                            <div className="ws-2">
                                                <input type="text" data-ng-model="searchC.isrcOrCatNum" className="form-control-single " placeholder="ISRC / Song / Catalog" />
                                            </div>
                                            <div className="ws-3">
                                                <input type="text" data-ng-model="searchC.repItemCodeSold" className="form-control-single " ng-value="catalog.selectedFormat.repItemCodeSold" placeholder="Contract / Class List" />
                                            </div>
                                            <div className="ws-2 pull-right pll">
                                                <button className="btn btn-small btn-pink" data-ng-click="setSearchCat(null)" title="Clear search form">
                                                    <i className="icon-refresh"></i>
                                                </button>
                                                <button className="btn icon-btn edit btn-small " data-ng-click="loadSystemCatalogues(searchC);">
                                                    <i className="icon-search"></i>
                                                    Search
                                                </button>
                                            </div>
                                        </div>
                                    </div>


                                    {
                                        searchError && <div className="alert alert-info">Fill in at least one search criteria to proceed.</div>
                                    }

                                    <ul className="nav nav-tabs nav-justified mt" data-ng-show="showSystemLists">
                                        <li>
                                            <a href="javascript: void(0)" data-ng-click="tabC.current = 1; loadSystemCatalogues();" >Releases</a>
                                        </li>
                                        <li>
                                            <a href="javascript: void(0)" data-ng-click="tabC.current = 2; loadSystemCatalogues();" >Track(s) / Song(s)</a>
                                        </li>
                                        <li>
                                            <a href="javascript: void(0)" data-ng-click="tabC.current = 3; loadSystemCatalogues();" >Contract</a>
                                        </li>
                                        <li>
                                            <a href="javascript: void(0)" data-ng-click="tabC.current = 4; loadSystemCatalogues();" >Class List</a>
                                        </li>
                                    </ul>
                                    <div className="slide" data-ng-show="showSystemLists &amp;&amp; tabC.current == 1">
                                        <div className="clearfix mt" data-ng-show="allCompilations.length &gt; 0">
                                            <div className="form-format ws-12">
                                                <label className="control-label ">Filter</label>
                                                <div className="label-entries">
                                                    <input type="text" className="input-sm " placeholder="Filter table below" data-ng-model="filter.compilation" id="compilation" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="box-header well mt ws-12" data-ng-show="catalogUnmatchedTotalItems &gt; 0">
                                            <h4 >
                                                record(s) found
                                            </h4>
                                        </div>

                                        {allFilteredCompilations &&
                                            <div className="alert alert-info mt " data-ng-hide="allFilteredCompilations.length &gt; 0">
                                                No releases found
                                            </div>
                                        }
                                        <table className="table" data-ng-show="filteredCompilations.length &gt; 0">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th >Catalog</th>
                                                    <th >Barcodenum</th>
                                                    <th >Artist</th>
                                                    <th >Title</th>
                                                    <th >Format</th>
                                                    <th >Label</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                        <div className="clearfix">


                                        </div>
                                    </div>
                                    <div className="slide" data-ng-show="showSystemLists &amp;&amp; tabC.current == 2">
                                        <div className="clearfix mt" data-ng-show="allTracks.length &gt; 0">
                                            <div className="form-format ws-12">
                                                <label className="control-label ">Filter</label>
                                                <div className="label-entries">
                                                    <input type="text" className="input-sm " placeholder="Filter table below" data-ng-model="filter.track" id="track" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="box-header well mt" data-ng-show="catalogUnmatchedTotalItems &gt; 0">
                                            <h4 >
                                                record(s) found
                                            </h4>
                                        </div>
                                        {allFilteredTracks &&
                                            <div className="alert alert-info mt " data-ng-hide="allFilteredTracks.length &gt; 0">No tracks found
                                            </div>}
                                        <table className="table" data-ng-show="filteredTracks.length &gt; 0">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th >Track(s)/Song(s) ISRC</th>
                                                    <th >Track(s)/Song(s) Artist</th>
                                                    <th >Title</th>
                                                    <th >Title Version</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                        <div className="clearfix">

                                        </div>
                                    </div>

                                    <div className="slide" data-ng-show="showSystemLists &amp;&amp; tabC.current == 3">
                                        <div className="clearfix mt" data-ng-show="allContracts.length &gt; 0">
                                            <div className="form-format ws-12">
                                                <label className="control-label ">Filter</label>
                                                <div className="label-entries">
                                                    <input type="text" className="input-sm " placeholder="Filter table below" data-ng-model="filter.contracts" id="contracts" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="box-header well mt" data-ng-show="catalogUnmatchedTotalItems &gt; 0">
                                            <h4 >
                                                record(s) found
                                            </h4>
                                        </div>
                                        {allFilteredContracts &&
                                            <div className="alert alert-info mt " data-ng-hide="allFilteredContracts.length &gt; 0">
                                                No releases found
                                            </div>}
                                        <table className="table" data-ng-show="filteredContracts.length &gt; 0">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th >Contract Artist</th>
                                                    <th >contractRefNum</th>
                                                    <th >Contract Title</th>
                                                    <th >Kontact Display</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                        <div className="clearfix">

                                        </div>
                                    </div>
                                    <div className="slide" data-ng-show="showSystemLists &amp;&amp; tabC.current == 4">
                                        <div className="clearfix mt" data-ng-show="allClassList.length &gt; 0">
                                            <div className="form-format ws-12">
                                                <label className="control-label ">Filter</label>
                                                <div className="label-entries">
                                                    <input type="text" className="input-sm " placeholder="Filter table below" data-ng-model="filter.classList" id="Text1" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="box-header well mt" data-ng-show="catalogUnmatchedTotalItems &gt; 0">
                                            <h4 >
                                                record(s) found
                                            </h4>
                                        </div>
                                        {allFilteredClassList &&
                                            <div className="alert alert-info mt " data-ng-hide="allFilteredClassList.length &gt; 0">No Class List
                                                found
                                            </div>}
                                        <table className="table" data-ng-show="filteredClassList.length &gt; 0">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th >ISRC</th>
                                                    <th >Class List</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            </tbody>
                                        </table>
                                        <div className="clearfix">

                                        </div>
                                    </div>
                                </form>



                                {repItemCodeSoldEmpty &&
                                    <div className="alert alert-danger mt" data-ng-show="catalog.repItemCodeSoldEmpty">
                                        Rep Item Code Sold is Empty
                                    </div>
                                }
                                {
                                    saveDuplicateError &&
                                    <div className="alert alert-info">
                                        The Rep Item Code Sol has already been aliased
                                    </div>
                                }
                                {catalogSaveError &&
                                    <div className="alert alert-danger" data-ng-show="catalog.saveError">
                                        You need to select at least one catalog and one system catalog to match
                                    </div>
                                }
                                {
                                    codeError &&
                                    <div className="alert alert-info">
                                        Rep Item Code Sold or ISRC contain unwanted characters. Please choose another one.
                                    </div>
                                }
                                {catalogSaveSuccess &&
                                    <div className="alert alert-success" data-ng-show="catalog.saveSuccess">
                                        Catalogs have been matched successfully
                                    </div>
                                }
                            </div>
                            <div className="box-footer clearfix">
                                <div className="pull-right">
                                    <button className="btn icon-btn edit btn-sm ml " ng-click="saveCatalogues(catalog.selectedFormat, catalog.ourCatalog, catalog.ourCatalog )">
                                        <i className="icon-save-disk"></i>
                                        Save Link
                                    </button>
                                </div>
                                <div className="form-format pull-left mt ws-9">
                                    <label >
                                        <input type="checkbox" data-ng-model="catalog.isGen" />Create a general Alias
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="box">
                            <div className="box-header well">
                                <h2 >
                                    Existing Catalogs Aliases -  record(s) found
                                </h2>
                            </div>
                            <div className="box-content clearfix">
                                <div className=" form-horizontal form-condensed">
                                    <div className="form-format mb">
                                        <label className="control-label ">Search</label>
                                        <div className="label-entries">
                                            <div className="ws-3">
                                                <input type="text" className="input-sm m0 " placeholder="Enter exact Rep Item Code Sold / Reported Code" data-ng-model="filter.existCatalog" id="catLogue" />
                                            </div>
                                            <div className="">
                                                <button className="btn icon-btn edit" title="Search" data-ng-click="pages.alias = 1; loadCatalogAliases()">
                                                    <i className="icon-search"></i> Search
                                                </button>
                                            </div>
                                            <div className="ws-3">

                                                <button className="btn icon-btn edit ml " title="View all aliases" data-ng-click="pages.alias = 1; filter.existCatalog = ''; loadCatalogAliases(); ">
                                                    <i className="icon-search"></i> View All aliases
                                                </button>

                                                <button className="btn icon-btn edit ml " title="View all Account Code" onClick={matchingCalatog}>
                                                    <i className="icon-search"></i> View All
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {noExistingAliases && <div className="alert alert-info"> No existing catalogs aliases found for the selected account code or matching your search criteria </div>}
                        {catalogDeleteSuccess && <div className="alert alert-info" data-ng-show="catalog.deleteSuccess"> Alias deleted successfully </div>}

                        <div className="table-responsive_big">
                            <table className="table" data-ng-show="allExistingAliases.length &gt; 0">
                                <thead>
                                    <tr>
                                        <th >Reported code</th>
                                        <th >Matched code</th>
                                        <th >Account Code</th>
                                        <th >ISRC</th>
                                        <th >Catalog</th>
                                        <th >Album title</th>
                                        <th >Album artist</th>
                                        <th >Track title</th>
                                        <th >Track artist</th>
                                        <th >Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {matchingCatalogViewAll?.map(values => {
                                        return (
                                            <tr>
                                                <td>{values.theirCode}</td>
                                                <td>{values.ourCode}</td>
                                                <td>{values.accountCode}</td>
                                                <td>{values.iSrC}</td>
                                                <td>{values.ourCode}</td>
                                                <td>{values.albumTitle}</td>
                                                <td>{values.albumArtist}</td>
                                                <td>{values.trackTitle}</td>
                                                <td>{values.trackArtist}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="clearfix mt">

                        </div>

                    </div>}

                    {showtab === 4 && <div className="slide" data-ng-show="isActiveTab(3)">

                        <div className="box-header well">
                            <h2 ><i className="icon-play-outline"></i> Matching Songs</h2>
                        </div>

                        <div className="box-content">

                            {
                                updateMatchingResultsTrue && <div className="alert alert-info">Operation queued for processing</div>
                            }

                            {
                                updateMatchingResultsFalse && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>
                            }
                            <form className="form-horizontal form-condensed ng-pristine ng-valid">
                                <div className="form-format">
                                    <div className="form-horizontal">
                                        <div className="form-format mb ws-12">
                                            <label className="control-label ">Account Code*</label>
                                            <div className="label-entries">
                                                <select className="form-control " /* placeholder="Choose Account Code" */ ng-model="catalog.accountCode" id="accountCode" name="accountCode" ng-change="onChangeCatalogueAccountCode(catalog.accountCode)"><option value="" >Choose an Account Code</option></select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-format" data-ng-show="catalog.accountCode">
                                    <div className="form-horizontal">
                                        <div className="form-format mb ws-12">
                                            <label className="control-label ">Search</label>
                                            <div className="label-entries">
                                                <div className="ws-4">
                                                    <input type="text" className="input-sm m0 " placeholder="Search unmatched songs" data-ng-model="filter.catalog" id="catLog" />
                                                </div>
                                                <div className="ws-4">
                                                    <button className="btn icon-btn edit" data-ng-click="pages.unmatched = 1;loadSongByAccountCode()">
                                                        <i className="icon-search"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {catalogsUnMatched &&
                                    <div className="alert alert-info m0 mb" data-ng-show="catalogsUnMatched.length == 0 &amp;&amp; (catalog.accountCode.code != '' &amp;&amp; catalog.accountCode.code != null)">
                                        No catalogue found for the selected account code or matching your search criteria
                                    </div>}
                                {catalogsUnMatchedAccountCode &&
                                    <div className="alert alert-info m0 mb" data-ng-show="catalogsUnMatched.length == 0 &amp;&amp; (catalog.accountCode.code == '' || catalog.accountCode.code == null)">
                                        Select an account code
                                    </div>}

                                <div className="box-header well" data-ng-show="catalogUnmatchedTotalItems &gt; 0">
                                    <h4 >
                                        record(s) found
                                    </h4>
                                </div>
                                <div className="table-responsive_big">
                                    <table className="table t_margin" data-ng-show="catalogsUnMatched.length &gt; 0">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th >Rep item code sold</th>
                                                <th >
                                                    Song Title
                                                    <span ng-click="sortByValueOrder = true; sortBy = 'songTitle'; onMatchCataloguesRefresh();" className="icon-angle-up"></span>
                                                    <span ng-click="sortByValueOrder = false; sortBy = 'songTitle'; onMatchCataloguesRefresh();" className="icon-angle-down"></span>
                                                </th>
                                                <th >Writer</th>
                                                <th >Song 1</th>
                                                <th >Song 2</th>
                                                <th >Song 3</th>
                                                <th >Song 4</th>
                                                <th >Item code sold</th>
                                                <th >
                                                    Unmatched value

                                                    <span ng-click="sortByValueOrder = true; sortBy = 'monetaryValue'; onMatchCataloguesRefresh();" className="icon-angle-up"></span>
                                                    <span ng-click="sortByValueOrder = false; sortBy = 'monetaryValue'; onMatchCataloguesRefresh();" className="icon-angle-down"></span>
                                                </th>
                                                <th >Operation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="clearfix">


                                    <div className="page-size-control mt">
                                        <select title="Items per page" data-ng-options="item as item for item in pageSizes" data-ng-change="pages.unmatched=1;catalogUnmatchedPageChanged(pages.unmatched, catalogueItemsPerPage)" data-ng-model="catalogueItemsPerPage" data-ng-show="catalogUnmatchedTotalItems &gt; 10" className=""><option value="0" label="5">5</option><option value="1" selected label="10">10</option><option value="2" label="20">20</option><option value="3" label="50">50</option><option value="4" label="100">100</option></select>
                                    </div>

                                    <button className="pull-right icon-btn primary btn-xs " field-separator="," ng-csv="exportCUnmatchedRows()" csv-header="exportCUnmatchedHeaders()" data-ng-show="allcatalogsUnMatched.length &gt; 0">
                                        <i className="icon-download1"></i> Export
                                    </button>
                                    <button className="pull-right icon-btn primary btn-sm mtl" ng-show="catalogUnmatchedTotalItems &gt; 0" title="Export Unmatched Catalogs" ng-click="matchingCataloguesExport(catalog.accountCode.code);">
                                        <i className="icon-download1"></i> Export
                                    </button>
                                    <button className="btn icon-btn edit btn-sm pull-right mtl " ng-click="onMatchCataloguesRefresh()" data-ng-hide="catalogsUnMatched.length == 0 &amp;&amp; (catalog.accountCode.code == '' || catalog.accountCode.code == null)">
                                        <i className="icon-refresh"></i> Refresh
                                    </button>
                                </div>

                                <div className="form-format">
                                    <div className="ws-12">
                                        <div className="ws-2">
                                            <input type="text" data-ng-model="searchC.trackTitle" className="form-control-single " placeholder="Track(s)/Song(s) title" />
                                        </div>
                                        <div className="ws-2">
                                            <input type="text" data-ng-model="searchC.trackArtist" className="form-control-single " placeholder="Track(s)/Song(s) artist" />
                                        </div>
                                        <div className="ws-2">
                                            <input type="text" data-ng-model="searchC.isrcOrCatNum" className="form-control-single " placeholder="ISRC / Song / Catalog" />
                                        </div>
                                        <div className="ws-3">
                                            <input type="text" data-ng-model="searchC.repItemCodeSold" className="form-control-single " ng-value="catalog.selectedFormat.repItemCodeSold" placeholder="Contract / Class List" />
                                        </div>
                                        <div className="ws-2 pull-right pll">
                                            <button className="btn btn-small icon-btn delete" data-ng-click="setSearchCat(null)" title="Clear search form">
                                                <i className="icon-close"></i>
                                            </button>
                                            <button className="btn icon-btn edit btn-small " data-ng-click="loadSystemCatalogues(searchC);">
                                                <i className="icon-search"></i>
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {
                                    searchError && <div className="alert alert-info">Fill in at least one search criteria to proceed.</div>
                                }
                                <ul className="nav nav-tabs nav-justified" data-ng-show="showSystemLists">
                                    <li>
                                        <a href="javascript: void(0)" data-ng-click="tabC.current = 2; loadSystemCatalogues();" >Track(s) / Song(s)</a>
                                    </li>
                                    <li>
                                        <a href="javascript: void(0)" data-ng-click="tabC.current = 3; loadSystemCatalogues();" >Contract</a>
                                    </li>
                                    <li>
                                        <a href="javascript: void(0)" data-ng-click="tabC.current = 4; loadSystemCatalogues();" >Class List</a>
                                    </li>
                                </ul>
                                <div className="slide" data-ng-show="showSystemLists &amp;&amp; tabC.current == 1">
                                    <div className="clearfix mt" data-ng-show="allCompilations.length &gt; 0">
                                        <div className="form-format">
                                            <label className="control-label ">Filter</label>
                                            <div className="ws-6">
                                                <input type="text" className="input-sm " placeholder="Filter table below" data-ng-model="filter.compilation" id="compilation" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-header well mt" data-ng-show="catalogUnmatchedTotalItems &gt; 0">
                                        <h4 >
                                            record(s) found
                                        </h4>
                                    </div>
                                    {allFilteredCompilations &&
                                        <div className="alert alert-info mt " data-ng-hide="allFilteredCompilations.length &gt; 0">
                                            No releases found

                                        </div>}
                                    <table className="table" data-ng-show="filteredCompilations.length &gt; 0">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th >Catalog</th>
                                                <th >Barcodenum</th>
                                                <th >Artist</th>
                                                <th >Title</th>
                                                <th >Format</th>
                                                <th >Label</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                        </tbody>
                                    </table>
                                    <div className="clearfix">


                                    </div>
                                </div>
                                <div className="slide" data-ng-show="showSystemLists &amp;&amp; tabC.current == 2">
                                    <div className="clearfix mt" data-ng-show="allTracks.length &gt; 0">
                                        <div className="form-format ws-12">
                                            <label className="control-label ">Filter</label>
                                            <div className="label-entries">
                                                <input type="text" className="input-sm " placeholder="Filter table below" data-ng-model="filter.track" id="track" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-header well mt" data-ng-show="catalogUnmatchedTotalItems &gt; 0">
                                        <h4 >
                                            record(s) found
                                        </h4>
                                    </div>
                                    {allFilteredTracks &&
                                        <div className="alert alert-info mt " data-ng-hide="allFilteredTracks.length &gt; 0">No tracks found
                                        </div>}
                                    <table className="table" data-ng-show="filteredTracks.length &gt; 0">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th >Track(s)/Song(s) ISRC</th>
                                                <th >Track(s)/Song(s) Artist</th>
                                                <th >Title</th>
                                                <th >Title Version</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                        </tbody>
                                    </table>
                                    <div className="clearfix">

                                    </div>
                                </div>

                                <div className="slide" data-ng-show="showSystemLists &amp;&amp; tabC.current == 3">
                                    <div className="clearfix mt" data-ng-show="allContracts.length &gt; 0">
                                        <div className="form-format">
                                            <label className="control-label ">Filter</label>
                                            <div className="ws-6">
                                                <input type="text" className="input-sm " placeholder="Filter table below" data-ng-model="filter.contracts" id="contracts" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-header well mt" data-ng-show="catalogUnmatchedTotalItems &gt; 0">
                                        <h4 >
                                            record(s) found
                                        </h4>
                                    </div>
                                    {allFilteredContracts && <div className="alert alert-info mt " data-ng-hide="allFilteredContracts.length &gt; 0">
                                        No releases found
                                    </div>}
                                    <table className="table" data-ng-show="filteredContracts.length &gt; 0">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th >Contract Artist</th>
                                                <th >contractRefNum</th>
                                                <th >Contract Title</th>
                                                <th >Kontact Display</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                        </tbody>
                                    </table>
                                    <div className="clearfix">


                                    </div>
                                </div>

                                <div className="slide" data-ng-show="showSystemLists &amp;&amp; tabC.current == 4">
                                    <div className="clearfix mt" data-ng-show="allClassList.length &gt; 0">
                                        <div className="form-format ws-12">
                                            <label className="control-label ">Filter</label>
                                            <div className="label-entries">
                                                <input type="text" className="input-sm " placeholder="Filter table below" data-ng-model="filter.track" id="Text1" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-header well mt" data-ng-show="catalogUnmatchedTotalItems &gt; 0">
                                        <h4 >
                                            record(s) found
                                        </h4>
                                    </div>
                                    {allFilteredClassList &&
                                        <div className="alert alert-info mt " data-ng-hide="allFilteredClassList.length &gt; 0">No Class List found
                                        </div>
                                    }
                                    <table className="table" data-ng-show="filteredClassList.length &gt; 0">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th >ISRC</th>
                                                <th >Class List</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                        </tbody>
                                    </table>
                                    <div className="clearfix">

                                    </div>
                                </div>

                            </form>
                            {repItemCodeSoldEmpty &&
                                <div className="alert alert-danger mt" data-ng-show="catalog.repItemCodeSoldEmpty">
                                    Rep Item Code Sold is Empty
                                </div>
                            }
                            {
                                saveDuplicateError &&
                                <div className="alert alert-info">
                                    The Rep Item Code Sol has already been aliased
                                </div>
                            }
                            {catalogSaveError &&
                                <div className="alert alert-danger" data-ng-show="catalog.saveError">
                                    You need to select at least one catalog and one system catalog to match
                                </div>
                            }
                            {
                                codeError &&
                                <div className="alert alert-info">
                                    Rep Item Code Sold or ISRC contain unwanted characters. Please choose another one.
                                </div>
                            }
                            {catalogSaveSuccess &&
                                <div className="alert alert-success" data-ng-show="catalog.saveSuccess">
                                    Catalogs have been matched successfully
                                </div>
                            }
                        </div>

                        <div className="box-footer clearfix">
                            <div className="pull-right">
                                <button className="btn icon-btn edit btn-sm ml " ng-click="saveCatalogues(catalog.selectedFormat, catalog.ourCatalog, catalog.ourCatalog )">
                                    <i className="icon-save-disk"></i>
                                    Save Link
                                </button>
                            </div>
                            <div className="form-format pull-left mt ws-9">
                                <label >
                                    <input type="checkbox" data-ng-model="catalog.isGen" />Create a general Alias
                                </label>
                            </div>
                        </div>


                        <div className="box">
                            <div className="box-header well">
                                <h2 >
                                    Existing Catalogs Aliases -  record(s) found

                                </h2>
                            </div>
                            <div className="box-content clearfix">
                                <div className=" form-horizontal form-condensed">
                                    <div className="form-format ws-12 mb">
                                        <label className="control-label ">Search</label>
                                        <div className="label-entries">
                                            <div className="ws-3">
                                                <input type="text" className="input-sm m0 " placeholder="Enter exact Rep Item Code Sold / Reported Code" data-ng-model="filter.existCatalog" id="catLogue" />
                                            </div>
                                            <div className="">
                                                <button className="btn icon-btn edit" title="Search" data-ng-click="pages.alias = 1; loadCatalogAliases()">
                                                    <i className="icon-search"></i>
                                                </button>
                                            </div>
                                            <div className="ws-3">

                                                <button className="btn icon-btn edit ml " data-ng-click="pages.alias = 1; filter.existCatalog = ''; loadCatalogAliases(); ">
                                                    <i className="icon-search"></i> View all aliases
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {allExistingAliases &&
                            <div className="alert alert-info" data-ng-show="allExistingAliases.length == 0 &amp;&amp; loadOrSearchRequested">
                                No existing catalogs aliases found for the selected account code or matching your search criteria
                            </div>}
                        {catalogDeleteSuccess &&
                            <div className="alert alert-info" data-ng-show="catalog.deleteSuccess">
                                Alias deleted successfully
                            </div>
                        }

                        <div className="table-responsive_big">
                            <table className="table" data-ng-show="allExistingAliases.length &gt; 0">
                                <thead>
                                    <tr>
                                        <th >Reported code</th>
                                        <th >Matched code</th>
                                        <th >Song 1</th>
                                        <th >Song 2</th>
                                        <th >Song 3</th>
                                        <th >Song 4</th>
                                        <th >Song title</th>
                                        <th >Writer</th>
                                        <th >Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                        </div>

                        <div className="clearfix mt">

                        </div>

                    </div>}
                </div>

                <div className="box-footer">
                    <button className="btn icon-btn delete btn-sm " ng-click="closeFormatsPopup()"><i className="icon-close"></i>Close</button>
                    <button className="btn icon-btn edit btn-sm hide " data-ng-click="updateSystem()"><i className="icon-save"></i> Update system</button>
                    <button className="btn icon-btn edit btn-sm hide" data-ng-click="postFactSalesRaw()" data-ng-show="tabs.active == 2 || tabs.active == 3"><i className="icon-tick"></i> Commit</button>
                </div>
            </div>

        </Drawer>

    )
}